import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ShoesArticle from "@/pages/article-shoes/page";
import ReviewArticle from "@/pages/article-review/page";
import BestFindsArticle from "@/pages/article-best-finds/page";
import HoodiesArticle from "@/pages/article-hoodies/page";
import BeginnerGuideArticle from "@/pages/article-beginner/page";
import JacketsArticle from "@/pages/article-jackets/page";
import BagsArticle from "@/pages/article-bags/page";
import TshirtsArticle from "@/pages/article-tshirts/page";
import AccessoriesArticle from "@/pages/article-accessories/page";
import PantsArticle from "@/pages/article-pants/page";
import JerseyArticle from "@/pages/article-jersey/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-sheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-shoes",
    element: <ShoesArticle />,
  },
  {
    path: "/superbuy-spreadsheet-review",
    element: <ReviewArticle />,
  },
  {
    path: "/superbuy-spreadsheet-best-finds",
    element: <BestFindsArticle />,
  },
  {
    path: "/superbuy-spreadsheet-hoodies",
    element: <HoodiesArticle />,
  },
  {
    path: "/superbuy-spreadsheet-beginner-guide",
    element: <BeginnerGuideArticle />,
  },
  {
    path: "/superbuy-spreadsheet-jackets",
    element: <JacketsArticle />,
  },
  {
    path: "/superbuy-spreadsheet-bags",
    element: <BagsArticle />,
  },
  {
    path: "/superbuy-spreadsheet-tshirts",
    element: <TshirtsArticle />,
  },
  {
    path: "/superbuy-spreadsheet-accessories",
    element: <AccessoriesArticle />,
  },
  {
    path: "/superbuy-spreadsheet-pants",
    element: <PantsArticle />,
  },
  {
    path: "/superbuy-spreadsheet-jersey",
    element: <JerseyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;